import { createContext } from "react";

import { ExportPatientRecordHelper } from "./ExportPatientRecordHelper.ts";

export const ExportPatientRecordContext =
  createContext<ExportPatientRecordHelper>({} as ExportPatientRecordHelper);
